import { useMutation, useQuery } from '@tanstack/react-query'
import { useToast } from '@zet/common/components/toast'
import { i18n } from '@zet/localization'

import { getPaymentDetails, submitPaymentDetails } from './functions'

export const usePaymentDetails = () => {
  return useQuery(['useMyTeamsPaymentDetails'], getPaymentDetails)
}

export const useUpdatePaymentDetails = () => {
  const toast = useToast()
  return useMutation(submitPaymentDetails, {
    onSuccess(response) {
      if (response?.error) {
        toast?.show({
          intent: 'Error',
          heading: i18n.t('toastMessages.error'),
          description: response?.error?.message,
          hideAfter: 3000,
        })
      }
    },
    onError(error) {
      toast?.show({
        intent: 'error',
        heading: i18n.t('toastMessages.error'),
        description: i18n.t('toastMessages.failedToUpdatePaymentDetails'),
        hideAfter: 3000,
      })
    },
  })
}
